import script from "./Vue3CompositionAPI.vue?vue&type=script&setup=true&lang=js"
export * from "./Vue3CompositionAPI.vue?vue&type=script&setup=true&lang=js"

import "./Vue3CompositionAPI.vue?vue&type=style&index=0&id=f93396da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f93396da"]])

export default __exports__